import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createToken } from '../utils/create-token';

// eslint-disable-next-line require-unicode-regexp
var mediaRegex = /(!\[(?:[\0-\\\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\]\((?:[\0-\(\*-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\))|(\[!\[(?:[\0-\\\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\]\((?:[\0-\(\*-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\)\]\((?:[\0-\(\*-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\))/g;
var getUrl = function getUrl(state, str) {
  var res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
  if (res.ok) {
    var href = state.md.normalizeLink(res.str);
    if (state.md.validateLink(href)) {
      return href;
    }
  }
  return '';
};
var checkPreviousToken = function checkPreviousToken(type, acc) {
  return acc.length > 0 && acc[acc.length - 1].type === type;
};
var createMediaTokens = function createMediaTokens(url, state, acc) {
  var mediaSingleOpen = createToken(state, 'media_single_open');
  var media = createToken(state, 'media');
  media.attrs = [['url', getUrl(state, url)], ['type', 'external']];

  // This is a hack to get internal media to work
  // to recreate the image correctly we need to apply the pmAttrs from the image
  // We store the pmAttrs in the "fake" image url and apply them to the token
  if (url.includes('atlassianinternalmedia')) {
    try {
      var urlObject = new URL(getUrl(state, url));
      var params = urlObject.searchParams;
      if (params.toString()) {
        var pmAttrs = {};
        var _iterator = _createForOfIteratorHelper(params),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];
            pmAttrs[key] = value;
          }

          // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        media.pmAttrs = pmAttrs;
      }
    } catch (_unused) {}
  }
  var mediaSingleClose = createToken(state, 'media_single_close');
  acc.push(mediaSingleOpen, media, mediaSingleClose);
};
var createInlineTokens = function createInlineTokens(content, state, acc) {
  var paragraphOpen = createToken(state, 'paragraph_open');
  var inline = createToken(state, 'inline');
  inline.content = content;
  inline.children = [createToken(state, 'text')];
  var paragraphClose = createToken(state, 'paragraph_close');
  acc.push(paragraphOpen, inline, paragraphClose);
};

/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */
var findContent = function findContent(token) {
  var content = [];
  var lastIndex = 0;
  var match;
  mediaRegex.lastIndex = 0;

  // eslint-disable-next-line no-cond-assign
  while ((match = mediaRegex.exec(token.content)) !== null) {
    var matchedString = match[0];
    var matchIndex = match.index;
    if (lastIndex < matchIndex) {
      content.push(token.content.substring(lastIndex, matchIndex));
    }
    content.push(matchedString);
    lastIndex = matchIndex + matchedString.length;
  }
  if (lastIndex < token.content.length) {
    content.push(token.content.substring(lastIndex));
  }
  content = content.filter(function (item) {
    return item.length > 0;
  });
  return content;
};
export default function (md) {
  md.core.ruler.before('inline', 'media', function (state) {
    state.tokens = state.tokens.reduce(function (acc, token, index) {
      var type = token.type;
      if (type === 'inline' && mediaRegex.test(token.content)) {
        // If the previous token is a paragraph_open we want to remove it
        if (checkPreviousToken('paragraph_open', acc)) {
          acc.pop();
        }
        var content = findContent(token);
        content.forEach(function (item) {
          var doesMatch = /!\[(?:[\0-\\\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\]\((?:[\0-\(\*-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\)/.test(item);
          if (doesMatch) {
            createMediaTokens(item, state, acc);
          } else {
            createInlineTokens(item, state, acc);
          }
        });

        // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
        // or paragraph_close
      } else if (type === 'paragraph_close') {
        if (!checkPreviousToken('media_single_close', acc) && !checkPreviousToken('paragraph_close', acc)) {
          acc.push(token);
        }
      } else {
        acc.push(token);
      }
      return acc;
    }, []);
  });
}